import Modal from '~/js/components/global/Modal';

const ModalLevels = () => {
  const cdnUrl = window.beaches_app.global.cdn_url;

  return (
    <div>
      <Modal id="levels" className="modal-window modal-levels mfp-hide">
        <div className="container-fluid">
          <div className="row row-levels">
            <div className="xs-12 lg-4 txt-center icon-wrap">
              <i className="ic icon-logo-together-nest" />
            </div>
            <div className="popup-cont-inside xs-12 lg-8">
              <p>
                <span className="font-big">Together Nest Suites</span> are defined by exclusive amenities and unique designs, these luxurious
                              suites and villas create the ultimate escape for lovebirds. These well&#8211;appointed suites feature
                              lavish bathrooms and amenities such as plush terry robes, hand&#8211;embroidered Egyptian cotton
                              duvets,
                              HD smart TVs, and the attentive service of a personal butler.
              </p>
              <a href="/all-inclusive/accommodations/together-nest/" className="icon-button-next"><b>Learn More</b></a>
            </div>
          </div>
          <div className="row row-levels">
            <div className="xs-12 lg-4 txt-center icon-wrap">
              <i className="ic icon-butler-elite" />
            </div>
            <div className="popup-cont-inside xs-12 lg-8">
              <p>
                <span className="font-big">Butler&#8211;class</span> accomodations offer all that you would
                              expect in a well&#8211;staffed grand home with every amenity imaginable. Over&#8211;the&#8211;top luxurious baths,
                              an en&#8211;suite bar stocked with top&#8211;shelf liquors and wines, and the most indulgent bedding that
                              inspires your best night&#8217;s sleep ever. Everything feels better, tastes better, and creates the
                              most of memories when luxury is priority one.
              </p>
              <a href="/all-inclusive/butler-service/" className="icon-button-next"><b>Learn More</b></a>
            </div>
          </div>
          <div className="row row-levels">
            <div className="xs-12 lg-4 txt-center icon-wrap">
              {/* <i className="ic icon-logo-club-sandals" /> */}
              <img src={`${cdnUrl}/resorts/accommodations/beaches-concierge.png`} alt="beaches concierge"/>
            </div>
            <div className="popup-cont-inside xs-12 lg-8">
              <p>
                <span className="font-big">Club Sandals</span>, a place with extraordinary privileges,
                              unique experiences, and exceptional service for concierge guests of Sandals Resorts.
                              Extravagance is blended with remarkable amenities that completely redefine genuine hospitality
                              and allow guests to enjoy one&#8211;on&#8211;one service and complete relaxation in the comfort of a stylish
                              lounge.
              </p>
              <a href="/all-inclusive/concierge-service/" className="icon-button-next"><b>Learn More</b></a>
            </div>
          </div>
          <div className="row row-levels">
            <div className="xs-12 lg-4 txt-center icon-wrap">
              {/* <i className="ic icon-logo-sandals-luxury"/> */}
              <img src={`${cdnUrl}/resorts/accommodations/beaches-luxury.png`} alt="beaches luxury"/>
            </div>
            <div className="popup-cont-inside xs-12 lg-8">
              <p>
                <span className="font-big">Luxury</span> personified &#8211; that&#8217;s what you can expect when you
                              indulge in a Sandals Luxury All Inclusive vacation. Even our basic rooms offer luxurious
                              furnishings, highest quality linens and fine in&#8211;room amenities. At Sandals you&#8217;re always
                              immersed in utmost privilege and distinction in your own private sanctuary.
              </p>
              {/* <a href="#" className="icon-button-next"><b>Learn More</b></a>--> */}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalLevels;
